var SearchFilter = (function ($) {
    // show/hide search forms for pkw
    function initSearchTypeSwitch(selector) {
        $(selector).on('change', function () {
            showSearchForm(this);
        });
        $(selector).trigger("change");
    }

    function showSearchForm(selector) {
        if ($(selector).is(":checked")) {
            $(".search-filter-container .tyre-size-view").hide();
            $(".search-filter-container .search-filter-tab-1").hide();
            $(".search-filter-container .search-filter-tab-" + $(selector).data('vehicle-type')).show();
        } else {
            $(".search-filter-container .tyre-size-view").show();
            $(".search-filter-container .search-filter-tab-1").show();
            $(".search-filter-container .search-filter-tab-2").hide();
        }
    }

    function initSerpFilters () {
        //Serp filters show/hide
        if ($('.facettenfilter_element').length) {
            $('.facettenfilter_element').on('click', function (e) {
                if ($(e.target).hasClass('facettenfilter_element') || $(e.target).hasClass('filters-label')) {
                    $(this).toggleClass('active');
                    $(this).children('div').toggle();
                }
            });

            $('.filterFormField').each(function(index, value) {
                var isSelectedFacet;
                var $value = $(value);

                if ($value.attr('type') === 'checkbox' || $value.attr('type') === 'radio') {
                    isSelectedFacet = $value.is(":checked") && $value.val() !== "" && $value.val() !== "all";
                } else {
                    isSelectedFacet = $value.val() !== "" && $value.val() !== "all";
                }

                if (isSelectedFacet) {
                    if (!$value.closest(".facettenfilter_element").hasClass('active')) {
                        $value.closest(".facettenfilter_element").toggleClass('active');
                        $value.closest(".facettenfilter_element").children('div').toggle();
                    }
                }
            });
        }

        if ($('#minPrice').length) {
            var minPrice = parseInt($('#minPrice').val()) || 0;
            var maxPrice = parseInt($('#maxPrice').val()) || 0;

            var isSelectedMinPrice = minPrice !== 0 && minPrice > parseInt($('#availableMinPrice').val());
            var isSelectedMaxPrice = maxPrice !== 0 && maxPrice < Math.ceil(parseFloat($('#availableMaxPrice').val()));

            if (isSelectedMinPrice || isSelectedMaxPrice) {
                var facettenfilterNumeric = $(".facettenfilter_numeric");
                facettenfilterNumeric.toggleClass('active');
                facettenfilterNumeric.children('div').toggle();
            }
        }
    }

    function switchServicePartnerTabRadioButtons(selector) {
        $(selector).on('change', function() {
            var selectedTab = this.value;

            if (selectedTab === "dimension") {
                $(".search-filter-container .tyre-size-view").show();
                $(".search-filter-container .search-filter-tab-1").show();
                $(".search-filter-container .search-filter-tab-2").hide();
                $(".search-filter-container .search-filter-tab-3").hide();

                $(".tab1-" +$(this).data('vehicle-type')).css("color", "#ff9000;");
                $(".tab2-" +$(this).data('vehicle-type')).css("color", "#fff;");
                $(".tab3-" +$(this).data('vehicle-type')).css("color", "#fff;");

                $(".service-partner-icon").css("display", "none");
                $(".general-icon").css("display", "block");
            }

            if (selectedTab === "vehicle") {
                $(".search-filter-container .tyre-size-view").hide();
                $(".search-filter-container .search-filter-tab-1").hide();
                $(".search-filter-container .search-filter-tab-3").hide();
                $(".search-filter-container .search-filter-tab-" + $(this).data('vehicle-type')).show();

                $(".tab1-" +$(this).data('vehicle-type')).css("color", "#fff;");
                $(".tab2-" +$(this).data('vehicle-type')).css("color", "#ff9000;");
                $(".tab3-" +$(this).data('vehicle-type')).css("color", "#fff;");

                $(".service-partner-icon").css("display", "none");
                $(".general-icon").css("display", "block");
            }

            if (selectedTab === "service-partner") {
                $(".search-filter-container .tyre-size-view").hide();
                $(".search-filter-container .search-filter-tab-1").hide();
                $(".search-filter-container .search-filter-tab-3").show();
                $(".search-filter-container .search-filter-tab-2").hide();

                $(".tab1-" +$(this).data('vehicle-type')).css("color", "#fff;");
                $(".tab2-" +$(this).data('vehicle-type')).css("color", "#fff;");
                $(".tab3-" +$(this).data('vehicle-type')).css("color", "#ff9000;");

                $(".service-partner-icon").css("display", "block");
                $(".general-icon").css("display", "none");
            }
        });
    }

	// Actualize search vehicle type inputs and show/hide search type switcher for pkw
	function initVehicleTypeSwitch(selector) {
		$(selector).on('change', function () {
			var currentVehicleType = this.value;
			$("#searchForm")
				.find("input[type='hidden'][name='vehicleTypes']")
                .each(function () {
                    $this = $(this)
                    var facet = $this.data('facet-name');
                    if (facet === 'vehicleTypes[0]') {
                        $this.val(currentVehicleType)
                             .trigger("change");
                    } else {
                        if (currentVehicleType === "PKW") {
                            $this.prop('disabled', false);
                        } else {
                            $this.prop('disabled', true);
                        }
                    }
                });

			if (currentVehicleType === "MO") {
				$(".search-filter-season").hide();
				$("#vehicleType").val("MOTTO");
			} else {
				$(".search-filter-season").show();
                $("#vehicleType").val("PKW");
			}
            $(".tyr-astnt-ct .search-filter-season").hide();

			var mainBgDiv = $(".header-component .main_back");
			mainBgDiv.removeClass (function (index, className) {
				return (className.match (/(^|\s)main-back-vehicle-\S+/g) || []).join(' ');
			});
			
			mainBgDiv.addClass("main-back-vehicle-"+ currentVehicleType);
			
			$(".search-filter-season input").prop("disabled", currentVehicleType === "MO");
			$("input.priceCategorySearchParam").prop("disabled", currentVehicleType === "MO");
			
			$(".search-filter-header-tricky-buttons .switch-filter-container").hide();
			$(".switch-filter-container .switch-type-search")
				.prop("checked", false)
				.trigger("change");

			if (currentVehicleType === "PKW" || currentVehicleType === "MO") {
				$(".search-filter-header-tricky-buttons .switch-filter-container-" + currentVehicleType).show();
			}

			initUITyreSizeSwitching(currentVehicleType);

            reloadPromotedTyres();

            var defaultSelectedButton = $(".switch-filter-container-" + currentVehicleType  + " .radio-buttons-wrap input[value='dimension']");
            defaultSelectedButton.prop('checked', true);
            defaultSelectedButton.trigger('change');

		});
		
		var currentVal = $(selector+":checked").val();
		if (currentVal === undefined) {
			currentVal = "PKW"
		}
		
		$(selector+"[value="+currentVal+"]")
			.prop("checked", true)
			.trigger("change");
	}

    //change tyre size on the image by vehicle type on home page
    function initUITyreSizeSwitching(vehicleType) {

        if (!$(".search-filter-container .tyre-size-view").length || !$(".additional-default-size").length) {
            return;
        }

        var $sizeInput = $(".additional-default-size[name='additional-size-" + vehicleType + "']");
        if (!$sizeInput.length) {
            return;
        }

        var $width = $sizeInput.data("width");
        var $profile = $sizeInput.data("profile");
        var $size = $sizeInput.data("size");

        if (!$width || !$profile || !$size) {
            $(".search-filter-container .tyre-size-view").html("");
        }

        var parts = [];

        parts.push($width);
        if ($profile) parts.push($profile);

        var $msg = parts.join(" / ");

        if ($size) {
            $msg += " R" + $size;
        }

        var $resultMsg = "";

        for (var i = 0; i < $msg.length; i++) {
            $resultMsg += "<span style='transform: rotate(" + (i+1)*8.1 + "deg);'>" + $msg.charAt(i) + "</span>";
        }

        $(".search-filter-container .tyre-size-view").html($resultMsg);
    }

    //init search by cart component
    function initSearchByCar() {

        $("#searchByBrandForm").on("submit", function () {
            $('#carselector-default-manufacturer').removeAttr('name');
            $('#carselector-default-model').removeAttr('name');
            $('#carselector-default-year-of-manufacture-type').removeAttr('name');
            $('#carselector-default-specific').removeAttr('name');
            $('#carselector-tyre-size').removeAttr('name');
        });

        $("#carselector-tyre-size").prop('disabled', true).trigger("focus");

        // CarSelector Default: load fift dropdown (type-details)
        $('#carselector-default-specific').on('change', function () {
            resetError();
            $("#carselector-default-error").fadeOut(300, function () {
                this.remove()
            });

            $("#carselector-tyre-size").prop('disabled', true)[0].options.length = 1;
            if (this.value === "") {
                return;
            }

            $.ajax({
                url: contextPath + "/delticom/brand/proxy" +
                "?rsmKBA=" + this.value +
                "&rsmHersteller=" + $("#carselector-default-manufacturer").val() +
                "&rsmPKWModell=" + $("#carselector-default-model").val() +
                "&rsmPKWVersion=" + $("#carselector-default-year-of-manufacture-type").val()
            }).done(function (result) {
                if (result === "NOK") {
                    showError();
                    return;
                }

                var data = JSON.parse(result);
                var dropdown = $("#carselector-tyre-size");

                $(dropdown).find('option:not([value=""])').remove();
                $.each(data, function (index, typedetails) {
                    if (data.selectedKey !== typedetails.v) {
                        $(dropdown).append("<option value='" + typedetails.v + "'>" + typedetails.d + "</option>");
                    } else {
                        $(dropdown).append("<option selected value='" + typedetails.v + "'>" + typedetails.d + "</option>");
                    }
                });

                if (data.length === 1) {
                    // select first element
                    $(dropdown).val(data[0].v);
                    $("#carselector-default-submit-tyres").prop('disabled', false);
                    $("#carselector-default-submit-tyres").show();
                    dropdown.trigger('change');
                    dropdown.prop('disabled', false).trigger("change");

                } else if (data.length === 0) {
                    showError();
                } else {
                    hideError();
                }

                $(dropdown).prop('disabled', false).trigger("focus");
                $("body").trigger($.Event("carselector-default-specific-done-loading"));
            }).fail(function (jqXHR) {
                // show foundation alert-box
                $("#carselector-error-div").show();
            });
        });

        $("#carselector-tyre-size").on('change', function () {
            preselect = false;
            if (this.value !== '') {
                populateForm($("#carselector-tyre-size").val());
                $("#carselector-default-submit-tyres").prop('disabled', false);
                $("#carselector-default-submit-tyres").show();
            } else {
                $("#carselector-default-submit-tyres").hide();
            }
        });

        $("#carselector-default-manufacturer").on('change', function () {
            preselect = false;
            if (this.value !== '') {
                $('input[name=vehicleManufacturer]').val(this.value);
            }
        });

        $("#carselector-default-model").on('change', function () {
            preselect = false;
            if (this.value !== '') {
                $('input[name=vehicleModel]').val(this.value.split("::")[1]);
            }
        });

        $("#carselector-default-year-of-manufacture-type").on('change', function () {
            preselect = false;
            if (this.value !== '') {
                $('input[name=vehicleSpecification]').val(this.value.split("::")[3] + " " + typeTranslation + " " + this.value.split("::")[4]);
            }
        });

        $("#carselector-default-specific").on('change', function () {
            preselect = false;
            if (this.value !== '') {
                $('input[name=vehicleId]').val(this.value.split("::")[0]);
                $('input[name=vehicleEngineType]').val($("#carselector-default-specific option:selected").text());
                $('input[name=fuelCode]').val(this.value.split("::")[1]);
            }
        });

        var populateForm = function (data) {
            var values = data.split("|"); // split by pipe creates individual values
            var formValues = {
                width: values[0],
                profile: values[1],
                constructionType: values[2],
                size: values[3],
                loadIndex: values[4],
                speedRating: (values[5]==="Y") ? "ZR,W,Y" : values[5]
            };

            for (var key in formValues) {
                $("#searchByBrandForm input[name='" + key + "']").val(formValues[key]);
            }
        };

        var showError = function () {
            $("#carselector-error-span").text(searchByCarErrorNoResults ? searchByCarErrorNoResults : "No results");
            $("#carselector-error-div").show();
        };

        var hideError = function () {
            $("#carselector-error-div").hide();
            $("#carselector-tyre-size").prop('disabled', false).trigger("chosen:updated");
        };

    }

    function reloadPromotedTyres() {
        setupPromotedProducts(true, setupTirendoPromotedProductsView)
    }

    function setupTirendoPromotedProductsView(view) {
        var $promotedTyresBlock = $("#promotedTyresBlock");
        if ($promotedTyresBlock.length > 0) {
            $promotedTyresBlock.empty();
            $promotedTyresBlock.html(view);
        }
    }

    return {
        initSearchTypeSwitch: initSearchTypeSwitch,
        showSearchForm: showSearchForm,
        initVehicleTypeSwitch: initVehicleTypeSwitch,
        initSearchByCar: initSearchByCar,
        initSerpFilters: initSerpFilters,
        switchServicePartnerTabRadioButtons: switchServicePartnerTabRadioButtons
    }
})(jQuery);

$(document).ready(function () {

    if ($(".search-filter-container .vehicle-type-switcher").length) {
        SearchFilter.initVehicleTypeSwitch(".search-filter-container .vehicle-type-switcher input[type='radio']");
    }

    if ($(".switch-filter-container .switch-type-search").length) {
        SearchFilter.initSearchTypeSwitch(".switch-filter-container .switch-type-search");
    }

    if ($(".switch-filter-container .radio-buttons-wrap").length) {
        SearchFilter.switchServicePartnerTabRadioButtons(".switch-filter-container .radio-buttons-wrap input[type='radio']");
    }

    if ($("#searchByBrandForm.car-selector-form").length) {
        SearchFilter.initSearchByCar();
    }

    SearchFilter.initSerpFilters();

});

$(window).on("load", function() {
    $('input[name="vehicle-type"]:checked').prop('checked', true).trigger('change');
    if ($(".switch-filter-container .switch-type-search").length) {
        SearchFilter.showSearchForm(".switch-filter-container .switch-type-search");
    }

    if ($("#defaultTab").val() === 'car') {
        $('.switch-wrapper__label[for="swich-filter-PKW"]').click();
    }
});